var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkinline = function SvgExternalLinkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0080FF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M11.5 7.334V11.3m0 .034H4v-7.5h4M10 2.334h3v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0080FF",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.75 7.584 4.5-4.5"
  })));
};
export default SvgExternalLinkinline;